const ASSESSMENT_TOOL = {
    EVENT: 'HRAssessmentQ${questionIndex}',
    EVENT_PROPERTIES: {
        DESCRIPTION: 'Q${questionIndex} radio button clicked on assessment test answer',
    },
};

export default ASSESSMENT_TOOL;
